import Header from "@/components/Header";
import Footer from "@/components/Footer";
import SEOHead from "@/components/SEOHead";
import { motion } from "framer-motion";

const UnsereHaltung = () => (
  <>
    <SEOHead title="Unsere Haltung – Leadership Focus" description="Brückenbauer für nachhaltige Veränderung. Neurowissenschaftlich-systemische Haltung für moderne Führung. Leadership Focus München." canonical="https://leadership-focus.de/unsere-haltung" />
    <Header />
    <main className="min-h-[60vh]">
      {/* Hero / Einleitung */}
      <section className="relative bg-primary/5 py-20 md:py-28">
        <div className="container max-w-3xl text-center">
          <motion.h1
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            className="text-4xl md:text-5xl font-serif font-bold text-foreground mb-6"
          >
            Unsere Haltung
          </motion.h1>
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.15 }}
            className="text-lg md:text-xl leading-relaxed text-muted-foreground"
          >
            Wir vereinen tiefgreifendes Verständnis für neurowissenschaftliche Erkenntnisse mit einer systemischen und menschlich zugewandten Haltung – so verstehen wir uns als Brückenbauer für nachhaltige Veränderung – und begleiten Sie dabei, moderne Führung langfristig wirksam werden zu lassen.
          </motion.p>
        </div>
      </section>
    </main>
    <Footer />
  </>
);

export default UnsereHaltung;
